import React from 'react';
import { Tooltip, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './style.css';

const benTooltip = (props) => {
  return <Tooltip {...props}>
    <div className='step-container'>
      <h3>{props.title}</h3>
      <p className='mt-3' dangerouslySetInnerHTML={{ __html: props.content }} />

      {props.link && <div className='mt-3'>
        <a target='__blank' href="https://static1.squarespace.com/static/611337e8c220ef66fbc3f919/t/64a5d1fa0d77a55bfe7447b0/1688588806355/Survey+Explorer+Quick+Start+Guide">Learn more about filters {'>'} </a>
      </div>}
      <div className='button-container text-right mt-3'>
        <Button variant="light" onClick={props.close}>Done</Button>
      </div>
    </div>
  </Tooltip>
}

benTooltip.propTypes = {
  close: PropTypes.func.isRequired,
};


export default benTooltip;
